// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 650px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 8px 32px;
  }

  .app-bar .app-bar__brand h1 {
    font-size: 1.5em;
  }

  .app-bar .app-bar__menu {
    display: none;
  }

  .app-bar .app-bar__navigation {
    position: static;
    width: 100%;
  }

  .app-bar .app-bar__navigation ul li {
    display: inline-block;
  }

  .app-bar .app-bar__navigation ul li a {
    display: inline-block;
    /* width: 65px; */
    text-align: center;
    margin: 0;
  }

  .movies {
    grid-template-columns: 1fr 1fr;
  }

  .movie {
    grid-template-columns: auto 1fr;
  }

  .movie .movie__title {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .movie .movie__overview {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}

@media screen and (min-width: 800px) {
  .app-bar .app-bar__brand h1 {
    font-size: 2em;
  }
}

@media screen and (min-width: 850px) {
  .movies {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 850px) {
  .sort-card {
    display: block;
  }

  .card-wishlist {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1035px) {
  .judul-landing-page {
    color: white !important;
    background-color: transparent !important;
    /* padding: 0 -100px; */
    font-size: 38px;
  }

  .deskripsi-landing-page {
    font-size: 18px !important;
  }
}

@media screen and (min-width: 1200px) {
  .movies {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (min-width: 1600px) {
  .movies {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* Responsive styling */
@media (max-width: 768px) {
  .card-faq {
    max-width: 100%; /* full-width pada perangkat kecil */
  }
}

@media screen and (max-width: 867px) {
  .detail-content {
    flex-direction: column; /* Ubah layout menjadi kolom */
    align-items: center; /* Selaraskan elemen ke tengah */
  }

  .detail-image {
    margin-bottom: 16px; /* Tambahkan jarak antara gambar dan teks */
  }
  .modal {
    margin-top: 20px;
  }
}

/* video */
@media screen and (max-width: 850px) {
  .video-content {
    flex-direction: column-reverse;
    gap: 20px;
    align-items: center;
    text-align: center;
  }

  .video-text {
    font-size: 20px;
  }

  .video-text h2 {
    font-size: 24px;
  }

  .video-text p {
    font-size: 18px;
    padding-top: 8px;
  }

  .video-frame {
    position: relative;
    width: 100%;
    max-width: 600px;
    padding-top: 56.25%; /* 16:9 aspect ratio */
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .video-frame video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

/* Responsive for Admin Bouquet Page */
@media (max-width: 1100px) {
  .bouquet-page {
    padding: 1rem 0.5rem !important;
    /* max-width: 100vw !important; */
    box-sizing: border-box;
  }
  .bouquet-table-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .bouquet-table {
    min-width: 700px;
    width: 100%;
    border-collapse: collapse;
    background: #fafbfc;
  }
  .bouquet-table th,
  .bouquet-table td {
    padding: 7px 4px;
    font-size: 0.97em;
    word-break: break-word;
    max-width: 160px;
    white-space: normal;
  }
}

@media (max-width: 700px) {
  .bouquet-page {
    padding: 0.5rem 0.1rem !important;
    /* max-width: 100vw !important; */
  }
  .bouquet-table-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .bouquet-table {
    min-width: 500px;
    font-size: 0.93em;
  }
}

@media (max-width: 1024px) {
  .bouquet-table th,
  .bouquet-table td {
    padding: 10px 6.1px;
    font-size: 0.93em;
    max-width: 115px;
    white-space: normal;
  }
}

/* Generic responsive table wrapper */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1.5rem;
  /* Remove any padding that could cut off scroll */
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* Style horizontal scrollbar for all responsive tables */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}
.table-responsive::-webkit-scrollbar-thumb {
  background: #eee;
  border-radius: 4px;
}

@media (min-width: 475px) {
  .bouquet-feedback-link {
    margin-bottom: 0.2em;
  }
}

@media (min-width: 584px) {
  .bouquet-feedback-link {
    margin-bottom: 0.4em;
  }
}

/* Responsive: Make all admin tables horizontally scrollable on small screens */
@media (max-width: 900px) {
  .bouquet-feedback-link {
    margin-bottom: px;
  }
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .bouquet-table,
  .admin-feedback-table {
    min-width: 700px; /* Make sure this is wide enough for all columns */
    width: unset !important; /* Remove width: 100% or width: auto that may restrict scroll */
    display: table; /* Use table layout for proper column sizing */
    table-layout: auto;
  }
}

/* On very small screens, allow even smaller min-width for both tables */
@media (max-width: 500px) {
  .bouquet-table,
  .admin-feedback-table {
    min-width: 650px;
  }
}

/* Responsive: Modal centering for admin pages */
@media (max-width: 600px) {
  .bouquet-modal-content {
    margin: 10px auto !important;
    padding: 17px !important;
    width: 350px !important;
    max-width: 400px !important;
  }
}

/* Responsive: Action buttons stack vertically on small screens */
@media (max-width: 600px) {
  .bouquet-action-center {
    flex-direction: column;
    gap: 6px;
    align-items: stretch;
  }
}

/* Responsive: Search row stack on small screens */
@media (max-width: 975px) {
  .bouquet-search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    margin-top: 0;
    margin-bottom: 10px;
  }
  .bouquet-search-input,
  .bouquet-search-btn {
    width: 100%;
    margin-top: 0;
  }
}

/* --- Fix: Always keep margin/white space on the edge for .bouquet-page and .feedback-page --- */
.bouquet-page,
.feedback-page {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);
  margin: 2rem auto;
  padding: 1rem 2rem 2rem 2rem;
  max-width: 1200px; /* match style.css */
  box-sizing: border-box;
}

@media (max-width: 1920px) {
  .bouquet-page,
  .feedback-page {
    margin: 0.2rem 2vw !important;
    padding: 1.2rem 2vw 1.2rem 2vw !important;
    max-width: 98vw !important;
    border-radius: 16px;
    box-sizing: border-box;
  }
}
@media (max-width: 900px) {
  .bouquet-page,
  .feedback-page {
    margin: 0.2rem 2vw !important;
    padding: 0.9rem 1.5rem 1rem 1.5rem !important;
    max-width: 99vw !important;
    border-radius: 14px;
    box-sizing: border-box;
  }
}
@media (max-width: 700px) {
  .bouquet-page,
  .feedback-page {
    margin: 0.2rem 2vw !important;
    padding: 0.9rem 1.5rem 1rem 1.5rem !important;
    max-width: 100vw !important;
    border-radius: 12px;
    box-sizing: border-box;
  }
}

/* Responsive font size for admin page titles and links */
.bouquet-title {
  font-size: clamp(1.15rem, 4vw, 2.2rem);
  word-break: break-word;
}
.bouquet-feedback-link,
#bouquet-feedback-link,
#feedback-bouquet-link {
  font-size: clamp(0.87rem, 2.5vw, 1.2rem);
  word-break: break-word;
}

/* Responsive font size for table headers and cells */
.bouquet-table th,
.bouquet-table td,
.admin-feedback-table th,
.admin-feedback-table td {
  font-size: clamp(0.85rem, 2.5vw, 1.05rem);
  word-break: break-word;
}

/* Responsive font size for search input and button */
.bouquet-search-input,
.bouquet-search-btn {
  font-size: clamp(0.9rem, 2.5vw, 1.05rem);
}

/* Responsive font size for modal titles */
.bouquet-modal-content h3 {
  font-size: clamp(1.1rem, 4vw, 1.5rem);
}

/* Responsive font size for action buttons */
.bouquet-action-btn,
.bouquet-submit-btn,
.bouquet-cancel-btn,
.bouquet-tambah-btn,
.bouquet-logout-btn {
  font-size: clamp(0.9rem, 2.5vw, 1.05rem);
}

/* Ensure .bouquet-header stays inside the white card and never overflows */
.bouquet-header {
  box-sizing: border-box;
  width: 100%;
  padding-top: 0.2rem;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}

/* On small screens, add extra horizontal padding to .bouquet-header */
@media (max-width: 700px) {
  .bouquet-header {
    /* padding-left: 0.5rem; */
    padding-right: 0.5rem;
  }

  .detail-buttons {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-top: 20px;
  }

  .detail-buttons button:nth-child(4),
  .detail-buttons button:nth-child(5) {
    grid-column: span 1;
  }

  .detail-buttons button:nth-child(4) {
    grid-column-start: 1;
  }
  .detail-buttons button:nth-child(5) {
    grid-column-start: 2;
  }
}

@media (max-width: 500px) {
  .bouquet-header {
    padding-left: 1px;
    padding-right: 2vw;
  }
}

/* Prevent .bouquet-header children from overflowing horizontally */
.bouquet-header > * {
  max-width: 100%;
  box-sizing: border-box;
  word-break: break-word;
  overflow-wrap: break-word;
}

@media screen and (max-width: 500px) {
  .feedback-title .part-kirim,
  .feedback-title .part-feedback {
    display: block; /* Membuat setiap bagian memulai baris baru */
    line-height: 1.2; /* Sesuaikan sesuai kebutuhan untuk jarak antar baris */
    margin-bottom: 5px; /* Memberi sedikit jarak di bawah setiap baris, sesuaikan sesuai kebutuhan */
  }

  .feedback-title {
    margin-bottom: 0; /* Hapus margin bawah untuk baris terakhir jika tidak diperlukan */
  }

  /* Opsional: Jika Anda ingin menghilangkan spasi kosong yang mungkin muncul di antara span jika ada di HTML asli */
  .feedback-title {
    font-size: 1.7rem; /* Contoh: kembalikan ukuran font jika ada yang dikomentari sebelumnya */
    white-space: normal; /* Memastikan teks dapat membungkus secara normal */
  }

  .feedback-logout-btn {
    margin-top: -30px !important;
    /* padding-top: 800px !important; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wCAAwC;IACxC,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe,EAAE,oCAAoC;EACvD;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,8BAA8B;IACtD,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;IACE,mBAAmB,EAAE,2CAA2C;EAClE;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,UAAU;AACV;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAE,sBAAsB;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,iCAAiC;EACnC;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,iDAAiD;EACjD,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;EACA;;IAEE,gBAAgB,EAAE,kDAAkD;IACpE,uBAAuB,EAAE,+DAA+D;IACxF,cAAc,EAAE,8CAA8C;IAC9D,kBAAkB;EACpB;AACF;;AAEA,wEAAwE;AACxE;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA,iEAAiE;AACjE;EACE;IACE,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;EACtB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,aAAa;IACb,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,iGAAiG;AACjG;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB;qCACmC;EACnC,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB,EAAE,oBAAoB;EACvC,sBAAsB;AACxB;;AAEA;EACE;;IAEE,6BAA6B;IAC7B,yCAAyC;IACzC,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;EACxB;AACF;AACA;EACE;;IAEE,6BAA6B;IAC7B,6CAA6C;IAC7C,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;EACxB;AACF;AACA;EACE;;IAEE,6BAA6B;IAC7B,6CAA6C;IAC7C,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,yDAAyD;AACzD;EACE,sCAAsC;EACtC,sBAAsB;AACxB;AACA;;;EAGE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;;;;EAIE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;;EAEE,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;;;;;EAKE,wCAAwC;AAC1C;;AAEA,2EAA2E;AAC3E;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,cAAc,EAAE,6CAA6C;IAC7D,gBAAgB,EAAE,uDAAuD;IACzE,kBAAkB,EAAE,4EAA4E;EAClG;;EAEA;IACE,gBAAgB,EAAE,kEAAkE;EACtF;;EAEA,kHAAkH;EAClH;IACE,iBAAiB,EAAE,wEAAwE;IAC3F,mBAAmB,EAAE,mDAAmD;EAC1E;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;AACF","sourcesContent":["@media screen and (min-width: 650px) {\n  .app-bar {\n    grid-template-columns: 1fr auto;\n    padding: 8px 32px;\n  }\n\n  .app-bar .app-bar__brand h1 {\n    font-size: 1.5em;\n  }\n\n  .app-bar .app-bar__menu {\n    display: none;\n  }\n\n  .app-bar .app-bar__navigation {\n    position: static;\n    width: 100%;\n  }\n\n  .app-bar .app-bar__navigation ul li {\n    display: inline-block;\n  }\n\n  .app-bar .app-bar__navigation ul li a {\n    display: inline-block;\n    /* width: 65px; */\n    text-align: center;\n    margin: 0;\n  }\n\n  .movies {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .movie {\n    grid-template-columns: auto 1fr;\n  }\n\n  .movie .movie__title {\n    grid-column-start: 1;\n    grid-column-end: 3;\n  }\n\n  .movie .movie__overview {\n    grid-column-start: 1;\n    grid-column-end: 3;\n  }\n}\n\n@media screen and (min-width: 800px) {\n  .app-bar .app-bar__brand h1 {\n    font-size: 2em;\n  }\n}\n\n@media screen and (min-width: 850px) {\n  .movies {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .sort-card {\n    display: block;\n  }\n\n  .card-wishlist {\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 1035px) {\n  .judul-landing-page {\n    color: white !important;\n    background-color: transparent !important;\n    /* padding: 0 -100px; */\n    font-size: 38px;\n  }\n\n  .deskripsi-landing-page {\n    font-size: 18px !important;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .movies {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media screen and (min-width: 1600px) {\n  .movies {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n  .card-faq {\n    max-width: 100%; /* full-width pada perangkat kecil */\n  }\n}\n\n@media screen and (max-width: 867px) {\n  .detail-content {\n    flex-direction: column; /* Ubah layout menjadi kolom */\n    align-items: center; /* Selaraskan elemen ke tengah */\n  }\n\n  .detail-image {\n    margin-bottom: 16px; /* Tambahkan jarak antara gambar dan teks */\n  }\n  .modal {\n    margin-top: 20px;\n  }\n}\n\n/* video */\n@media screen and (max-width: 850px) {\n  .video-content {\n    flex-direction: column-reverse;\n    gap: 20px;\n    align-items: center;\n    text-align: center;\n  }\n\n  .video-text {\n    font-size: 20px;\n  }\n\n  .video-text h2 {\n    font-size: 24px;\n  }\n\n  .video-text p {\n    font-size: 18px;\n    padding-top: 8px;\n  }\n\n  .video-frame {\n    position: relative;\n    width: 100%;\n    max-width: 600px;\n    padding-top: 56.25%; /* 16:9 aspect ratio */\n    border-radius: 20px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  }\n\n  .video-frame video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n/* Responsive for Admin Bouquet Page */\n@media (max-width: 1100px) {\n  .bouquet-page {\n    padding: 1rem 0.5rem !important;\n    /* max-width: 100vw !important; */\n    box-sizing: border-box;\n  }\n  .bouquet-table-wrapper {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .bouquet-table {\n    min-width: 700px;\n    width: 100%;\n    border-collapse: collapse;\n    background: #fafbfc;\n  }\n  .bouquet-table th,\n  .bouquet-table td {\n    padding: 7px 4px;\n    font-size: 0.97em;\n    word-break: break-word;\n    max-width: 160px;\n    white-space: normal;\n  }\n}\n\n@media (max-width: 700px) {\n  .bouquet-page {\n    padding: 0.5rem 0.1rem !important;\n    /* max-width: 100vw !important; */\n  }\n  .bouquet-table-wrapper {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .bouquet-table {\n    min-width: 500px;\n    font-size: 0.93em;\n  }\n}\n\n@media (max-width: 1024px) {\n  .bouquet-table th,\n  .bouquet-table td {\n    padding: 10px 6.1px;\n    font-size: 0.93em;\n    max-width: 115px;\n    white-space: normal;\n  }\n}\n\n/* Generic responsive table wrapper */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-bottom: 1.5rem;\n  /* Remove any padding that could cut off scroll */\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/* Style horizontal scrollbar for all responsive tables */\n.table-responsive::-webkit-scrollbar {\n  height: 8px;\n}\n.table-responsive::-webkit-scrollbar-thumb {\n  background: #eee;\n  border-radius: 4px;\n}\n\n@media (min-width: 475px) {\n  .bouquet-feedback-link {\n    margin-bottom: 0.2em;\n  }\n}\n\n@media (min-width: 584px) {\n  .bouquet-feedback-link {\n    margin-bottom: 0.4em;\n  }\n}\n\n/* Responsive: Make all admin tables horizontally scrollable on small screens */\n@media (max-width: 900px) {\n  .bouquet-feedback-link {\n    margin-bottom: px;\n  }\n  .table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .bouquet-table,\n  .admin-feedback-table {\n    min-width: 700px; /* Make sure this is wide enough for all columns */\n    width: unset !important; /* Remove width: 100% or width: auto that may restrict scroll */\n    display: table; /* Use table layout for proper column sizing */\n    table-layout: auto;\n  }\n}\n\n/* On very small screens, allow even smaller min-width for both tables */\n@media (max-width: 500px) {\n  .bouquet-table,\n  .admin-feedback-table {\n    min-width: 650px;\n  }\n}\n\n/* Responsive: Modal centering for admin pages */\n@media (max-width: 600px) {\n  .bouquet-modal-content {\n    margin: 10px auto !important;\n    padding: 17px !important;\n    width: 350px !important;\n    max-width: 400px !important;\n  }\n}\n\n/* Responsive: Action buttons stack vertically on small screens */\n@media (max-width: 600px) {\n  .bouquet-action-center {\n    flex-direction: column;\n    gap: 6px;\n    align-items: stretch;\n  }\n}\n\n/* Responsive: Search row stack on small screens */\n@media (max-width: 975px) {\n  .bouquet-search-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n    margin-top: 0;\n    margin-bottom: 10px;\n  }\n  .bouquet-search-input,\n  .bouquet-search-btn {\n    width: 100%;\n    margin-top: 0;\n  }\n}\n\n/* --- Fix: Always keep margin/white space on the edge for .bouquet-page and .feedback-page --- */\n.bouquet-page,\n.feedback-page {\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08),\n    0 1.5px 4px 0 rgba(0, 0, 0, 0.04);\n  margin: 2rem auto;\n  padding: 1rem 2rem 2rem 2rem;\n  max-width: 1200px; /* match style.css */\n  box-sizing: border-box;\n}\n\n@media (max-width: 1920px) {\n  .bouquet-page,\n  .feedback-page {\n    margin: 0.2rem 2vw !important;\n    padding: 1.2rem 2vw 1.2rem 2vw !important;\n    max-width: 98vw !important;\n    border-radius: 16px;\n    box-sizing: border-box;\n  }\n}\n@media (max-width: 900px) {\n  .bouquet-page,\n  .feedback-page {\n    margin: 0.2rem 2vw !important;\n    padding: 0.9rem 1.5rem 1rem 1.5rem !important;\n    max-width: 99vw !important;\n    border-radius: 14px;\n    box-sizing: border-box;\n  }\n}\n@media (max-width: 700px) {\n  .bouquet-page,\n  .feedback-page {\n    margin: 0.2rem 2vw !important;\n    padding: 0.9rem 1.5rem 1rem 1.5rem !important;\n    max-width: 100vw !important;\n    border-radius: 12px;\n    box-sizing: border-box;\n  }\n}\n\n/* Responsive font size for admin page titles and links */\n.bouquet-title {\n  font-size: clamp(1.15rem, 4vw, 2.2rem);\n  word-break: break-word;\n}\n.bouquet-feedback-link,\n#bouquet-feedback-link,\n#feedback-bouquet-link {\n  font-size: clamp(0.87rem, 2.5vw, 1.2rem);\n  word-break: break-word;\n}\n\n/* Responsive font size for table headers and cells */\n.bouquet-table th,\n.bouquet-table td,\n.admin-feedback-table th,\n.admin-feedback-table td {\n  font-size: clamp(0.85rem, 2.5vw, 1.05rem);\n  word-break: break-word;\n}\n\n/* Responsive font size for search input and button */\n.bouquet-search-input,\n.bouquet-search-btn {\n  font-size: clamp(0.9rem, 2.5vw, 1.05rem);\n}\n\n/* Responsive font size for modal titles */\n.bouquet-modal-content h3 {\n  font-size: clamp(1.1rem, 4vw, 1.5rem);\n}\n\n/* Responsive font size for action buttons */\n.bouquet-action-btn,\n.bouquet-submit-btn,\n.bouquet-cancel-btn,\n.bouquet-tambah-btn,\n.bouquet-logout-btn {\n  font-size: clamp(0.9rem, 2.5vw, 1.05rem);\n}\n\n/* Ensure .bouquet-header stays inside the white card and never overflows */\n.bouquet-header {\n  box-sizing: border-box;\n  width: 100%;\n  padding-top: 0.2rem;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 8px;\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* On small screens, add extra horizontal padding to .bouquet-header */\n@media (max-width: 700px) {\n  .bouquet-header {\n    /* padding-left: 0.5rem; */\n    padding-right: 0.5rem;\n  }\n\n  .detail-buttons {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .detail-buttons button:nth-child(4),\n  .detail-buttons button:nth-child(5) {\n    grid-column: span 1;\n  }\n\n  .detail-buttons button:nth-child(4) {\n    grid-column-start: 1;\n  }\n  .detail-buttons button:nth-child(5) {\n    grid-column-start: 2;\n  }\n}\n\n@media (max-width: 500px) {\n  .bouquet-header {\n    padding-left: 1px;\n    padding-right: 2vw;\n  }\n}\n\n/* Prevent .bouquet-header children from overflowing horizontally */\n.bouquet-header > * {\n  max-width: 100%;\n  box-sizing: border-box;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n@media screen and (max-width: 500px) {\n  .feedback-title .part-kirim,\n  .feedback-title .part-feedback {\n    display: block; /* Membuat setiap bagian memulai baris baru */\n    line-height: 1.2; /* Sesuaikan sesuai kebutuhan untuk jarak antar baris */\n    margin-bottom: 5px; /* Memberi sedikit jarak di bawah setiap baris, sesuaikan sesuai kebutuhan */\n  }\n\n  .feedback-title {\n    margin-bottom: 0; /* Hapus margin bawah untuk baris terakhir jika tidak diperlukan */\n  }\n\n  /* Opsional: Jika Anda ingin menghilangkan spasi kosong yang mungkin muncul di antara span jika ada di HTML asli */\n  .feedback-title {\n    font-size: 1.7rem; /* Contoh: kembalikan ukuran font jika ada yang dikomentari sebelumnya */\n    white-space: normal; /* Memastikan teks dapat membungkus secara normal */\n  }\n\n  .feedback-logout-btn {\n    margin-top: -30px !important;\n    /* padding-top: 800px !important; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
